<template>
  <div class="index" :style="{ paddingTop: statusBar + 'rem' }">
    <Header ref="header" title="忘记密码" :back="true" left="" />
    <div class="windowmain">
      <div class="boxmain">
        <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex: 0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">填写用户名</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">3</p>
            <p class="stepline"></p>
            <p class="itemp2">重置密码</p>
          </div>
          <div class="stepitem" style="flex: 0.5">
            <p class="itemp1">4</p>

            <p class="itemp2">完成</p>
          </div>
        </div>
        <div class="v_showdiv"></div>
        <van-form validate-first ref="form">
          <div class="boxinput">
            <p class="boxTitle">填写用户名</p>
            <div class="filed-vertical">
              <div class="lable"><span>*</span>登录用户名</div>
              <van-field
                name="certName"
                :rules="cerNameRules"
                v-model="certName"
                class="input"
                placeholder="请输入姓名"
              />
            </div>
            <div class="filed-vertical vertical1">
              <div class="lable"><span>*</span>图形验证码</div>
              <div class="verificationBox" style="position: relative">
                <van-field
                  v-model="checkCode"
                  name="checkCode"
                  :rules="checkCodeRules"
                  id="verifital_input"
                  class="input"
                  maxlength="4"
                  placeholder="请输入验证码"
                ></van-field>

                <div
                  @click="verificationCode"
                  id="verificationCode"
                  class="verificationCode"
                >
                  <div class="codeImg">
                    <img id="code_img" :src="base64img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin: 40px 16px 16px 16px">
            <van-button
              type="primary"
              class="btn1"
              size="large"
              @click="fromSubmit()"
              >下一步</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
  Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";
import { getUUID } from '@/views/components/swDate';
const getVerificationCode = function () {
    this.getUUID =getUUID() ;
   
  this.$http
    .get(
      "/nuserwebserver/forget/password/img?captchaKey="+this.getUUID
    )
    .then((res) => {
      this.pacClientId = res.data.captchaKey;
      this.base64img = res.data.img;
      this.checkCode = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
//查询状态
const getType = function () {
  let params = {
    captchaKey: this.pacClientId,
    captchaValue: this.checkCode,
    loginName: this.certName,
  };

  this.$http
    .post("/nuserwebserver/forget/password/verify/type", params)
    .then((res) => {
      if (res.code == "0") {
        this.$router.push({
          path: "/swforgotverify",
          query: {
            res:JSON.stringify( res.data),
            loginName: this.certName,
          },
        });
      } else {
        this.checkCode = "";
        this.getVerificationCode();
        this.$toast(res.msg);
      }
    })
    .catch(() => {
      this.$toast("查询失败");
    });
};
export default {
  name: "swforgotpsdIndex",
  data() {
    return {
      certName: "",
      nameTips: "用户名",
      certpsd: "",
      cerpsed: "",
      isrequset: false,
      checkMail: false,
      certNo: "",
      ieFlag: "",
      base64img: "",
      pacClientId: "",
      downIcon: true,
      downIcon1: true,
      getUUID:'',
      checkCode: "",
      passdType: "password",
      cerNameRules: [
        {
          required: true,

          message: "请输入用户名",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            return /^[0-9a-zA-Z_]{0,999999999999999}$/.test(value);
          },
          message: "用户名可录入英文字母，数字和_",
          trigger: "onBlur",
        },
      ],
      checkCodeRules: [
        {
          required: true,

          message: "请输入验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      model: {
        param: {
          seqNo: "",
          billType: "23003",
          projectSubCode: "2",
          status: "",
          pageSize: 10,
          pageNum: 0,
          businessNo: "",
          businessNo1: "",
          carNo: "",
          declareName: "",
          startDate: "",
          endDate: "",
        },
      },

      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getVerificationCode();
  },

  methods: {
    getType,
    fromSubmit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.getType();
        })
        .catch(() => {
          // this.$toast("失败");
        });
      // this.$router.push({
      //   path: "/swforgotverify",
      // });
    },
    getVerificationCode,
    verificationCode: function () {
      //  重新点击验证码
      this.getVerificationCode();
      this.checkCode = "";
    },
  },

  components: {
    Header,

    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }
.verificationCode {
}
.windowmain {
  width: 100%;
  .boxmain {
    width: 100%;
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .boxstep {
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
      padding: 14px 11px 16px 11px;
      .stepitem {
        flex: 1;
        position: relative;
        text-align: center;
        .stepline {
          position: absolute;
          width: 42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
          top: 9px;
        }
        .stepline2 {
          position: absolute;
          width: 50px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
          top: 9px;
        }
        .itemp1 {
          width: 17px;
          height: 17px;
          background: #d5d5d5;
          font-size: 11px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          line-height: 18px;
          display: block;
          position: relative;
          margin: 0 auto;
        }
        .itemp2 {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
      .stepitemactive {
        .itemp1 {
          background: #00599c;
        }
        .itemp2 {
          color: #00599c;
        }
      }
    }
  }
  .v_showdiv {
    height: 12px;
    background: #f7f8fa;
  }
  .boxinput {
    // margin-top: 12px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;

    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }
  ::v-deep .van-cell::after {
    border-bottom: 0px solid #ddd;
  }
  .vertical1 .van-cell {
    width: 68%;
  }
  .verificationCode {
    top: 7px;
  }
  .verificationCode .codeImg {
    width: 91px;
    height: 32px;
  }

  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
}
</style>